// 前端话题英文文案映射
import topicEn from './en-US';
import topicZh from './zh-CN';
// 语言
export { langEn, langCn } from './language';
// console.log(topicEnMap);
export const topicEnMap: { [key: string]: string } = topicEn;
// 前端话题中文文案映射
export const topicZhMap: { [key: string]: string } = topicZh;

export enum OVERALL_DEFAULT_INFO {
  DEFAULT_GAME_ID = 'ufc454d9b1af70b40588e2a6fa4da4a8b',
}

function makeMirror(obj: any) {
  return Object.entries(obj).reduce((curMap: any, cur: any) => {
    const curObj: any = { ...curMap };
    curObj[cur[1]] = cur[0];
    return curObj;
  }, {});
}

export const baseColors = [
  '#5086f3',
  '#69d19c',
  '#6e7794',
  '#f5d242',
  '#7f6ff1',
  '#5ec8f1',
  '#ad53d4',
  '#f19e55',
  '#488e89',
  '#f17c86',
];

export const extendColors = [
  '#3965CC',
  '#4DAB7D',
  '#4C526E',
  '#CFA92D',
  '#5E54CC',
  '#45A1CC',
  '#873BAD',
  '#CC7B3D',
  '#3F716E',
  '#CC5E6B',
];

export const lightColors = [
  '#A6C9FF',
  '#C0EBD2',
  '#B8BED1',
  '#FFF196',
  '#D2C8FD',
  '#B5EFFF',
  '#DFB2ED',
  '#FFD8AB',
  '#A9C7C3',
  '#FFCCCC',
];

/**
 * TODO: 其他系统使用
 * EChart 舆情统计图基本颜色
 */
export const chartAllColors = [...baseColors, ...extendColors, ...lightColors];

export const ratingColors = [
  '#F17C86',
  '#FFABAF',
  '#A9E1C3',
  '#69D19C',
  '#4DAB7D',
];

export enum SENTIMENT_COLOR {
  POSITIVE = '#69D19C',
  NEUTRAL = '#6E7794',
  NEGATIVE = '#F17C86',
}

export const sentimentColorMap: {
  sentimentType: 'Positive' | 'Neutral' | 'Negative';
  color: string;
}[] = [
  { sentimentType: 'Positive', color: '#69D19C' },
  { sentimentType: 'Neutral', color: '#6E7794' },
  { sentimentType: 'Negative', color: '#F17C86' },
];

export const regionEn: {
  [key: string]: string;
} = {
  AF: 'Africa',
  CHN: 'China(Mainland)',
  EUR: 'Europe',
  Global: 'Global',
  global: 'Global',
  IN: 'India',
  JPN: 'Japan',
  KR: 'South Korea',
  ME: 'Middle East',
  NA: 'North America',
  OA: 'Oceania',
  'Other Asia': 'Other Asia',
  'OTHER ASIA': 'Other Asia',
  SA: 'South America',
  SEA: 'Southeast Asia',
  HMT: 'HKG/OMA/TW',
  GLOBAL: 'Global',
  WE: 'West Europe',
  EE: 'East Europe',
};

export const regionEnMirror = makeMirror(regionEn);

export const regionCn: {
  [key: string]: string;
} = {
  AF: '非洲',
  CHN: '中国',
  EUR: '欧洲',
  Global: '全球',
  global: '全球',
  GLOBAL: '全球',
  IN: '印度',
  JPN: '日本',
  KR: '韩国',
  ME: '中东',
  NA: '北美洲',
  OA: '大洋洲',
  'Other Asia': '其他亚洲',
  'OTHER ASIA': '其他亚洲',
  SA: '南美',
  SEA: '东南亚',
  HMT: '港澳台',
  WE: '西欧',
  EE: '东欧',
};

export const regioNCnMirror = makeMirror(regionCn);

// 国家
export const countryEn: {
  [key: string]: string;
} = {
  ad: 'Andorra',
  ae: 'UAE',
  af: 'Afghanistan',
  ag: 'Antigua and Barbuda',
  al: 'Albania',
  am: 'Armenia',
  ao: 'Angola',
  ar: 'Argentina',
  at: 'Austria',
  au: 'Australia',
  az: 'Azerbaijan',
  ba: 'Bosnia and Herzegovina',
  bb: 'Barbados',
  bd: 'Bangladesh',
  be: 'Belgium',
  bf: 'Burkina Faso',
  bg: 'Bulgaria',
  bh: 'Bahrain',
  bi: 'Burundi',
  bj: 'Benin',
  bn: 'Brunei Darussalam',
  bo: 'Bolivia',
  br: 'Brazil',
  bs: 'Bahamas',
  bt: 'Bhutan',
  bw: 'Botswana',
  by: 'Belarus',
  bz: 'Belize',
  ca: 'Canada',
  cf: 'Central African Republic',
  cg: 'Congo',
  ch: 'Switzerland',
  ci: "Côte d'Ivoire",
  ck: 'Cook Islands',
  cl: 'Chile',
  cm: 'Cameroon',
  cn: 'China',
  co: 'Colombia',
  cr: 'Costa Rica',
  cu: 'Cuba',
  cv: 'Cabo Verde',
  cy: 'Cyprus',
  cz: 'Czechia',
  cw: 'Curaçao',
  de: 'Germany',
  dj: 'Djibouti',
  dk: 'Denmark',
  dm: 'Dominica',
  do: 'Dominican Republic',
  dz: 'Algeria',
  ec: 'Ecuador',
  ee: 'Estonia',
  eg: 'Egypt',
  er: 'Eritrea',
  es: 'Spain',
  et: 'Ethiopia',
  fi: 'Finland',
  fj: 'Fiji',
  fm: 'Micronesia',
  fo: 'Faroe Islands',
  fr: 'France',
  ga: 'Gabon',
  gb: 'United Kingdom',
  gd: 'Grenada',
  ge: 'Georgia',
  gh: 'Ghana',
  gm: 'Gambia',
  gn: 'Guinea',
  gq: 'Equatorial Guinea',
  gr: 'Greece',
  gt: 'Guatemala',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  hk: 'Hong Kong, China',
  hn: 'Honduras',
  hr: 'Croatia',
  ht: 'Haiti',
  hu: 'Hungary',
  id: 'Indonesia',
  ie: 'Ireland',
  il: 'Israel',
  in: 'India',
  iq: 'Iraq',
  ir: 'Iran',
  is: 'Iceland',
  it: 'Italy',
  jm: 'Jamaica',
  jo: 'Jordan',
  jp: 'Japan',
  ke: 'Kenya',
  kg: 'Kyrgyzstan',
  kh: 'Cambodia',
  ki: 'Kiribati',
  km: 'Comoros',
  kn: 'Saint Kitts and Nevis',
  kp: 'North Korea',
  kr: 'South Korea',
  kw: 'Kuwait',
  kz: 'Kazakhstan',
  la: "Lao People's Democratic Republic",
  lb: 'Lebanon',
  lc: 'Saint Lucia',
  lk: 'Sri Lanka',
  lr: 'Liberia',
  ls: 'Lesotho',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  lv: 'Latvia',
  ly: 'Libya',
  ma: 'Morocco',
  mc: 'Monaco',
  md: 'Republic of Moldova',
  me: 'Montenegro',
  mg: 'Madagascar',
  mh: 'Marshall Islands',
  mk: 'North Macedonia',
  ml: 'Mali',
  mm: 'Myanmar',
  mn: 'Mongolia',
  mo: 'Macau, China',
  mr: 'Mauritania',
  mt: 'Malta',
  mu: 'Mauritius',
  mv: 'Maldives',
  mw: 'Malawi',
  mx: 'Mexico',
  my: 'Malaysia',
  mz: 'Mozambique',
  na: 'Namibia',
  ne: 'Niger',
  ng: 'Nigeria',
  ni: 'Nicaragua',
  nl: 'Netherlands',
  no: 'Norway',
  np: 'Nepal',
  nr: 'Nauru',
  nu: 'Niue',
  nz: 'New Zealand',
  om: 'Oman',
  pa: 'Panama',
  pe: 'Peru',
  pg: 'Papua New Guinea',
  ph: 'Philippines',
  pk: 'Pakistan',
  pl: 'Poland',
  pt: 'Portugal',
  pw: 'Palau',
  py: 'Paraguay',
  qa: 'Qatar',
  ro: 'Romania',
  rs: 'Serbia',
  ru: 'Russian',
  rw: 'Rwanda',
  sa: 'Saudi Arabia',
  sb: 'Solomon Islands',
  sc: 'Seychelles',
  sd: 'Sudan',
  se: 'Sweden',
  sg: 'Singapore',
  si: 'Slovenia',
  sk: 'Slovakia',
  sl: 'Sierra Leone',
  sm: 'San Marino',
  sn: 'Senegal',
  so: 'Somalia',
  sr: 'Suriname',
  ss: 'South Sudan',
  st: 'Sao Tome and Principe',
  sv: 'El Salvador',
  sy: 'Syrian Arab Republic',
  sz: 'Eswatini',
  td: 'Chad',
  tg: 'Togo',
  th: 'Thailand',
  tj: 'Tajikistan',
  tk: 'Tokelau',
  tl: 'Timor-Leste',
  tm: 'Turkmenistan',
  tn: 'Tunisia',
  to: 'Tonga',
  tr: 'Turkey',
  tt: 'Trinidad and Tobago',
  tv: 'Tuvalu',
  tw: 'Taiwan, China',
  tz: 'United Republic of Tanzania',
  ua: 'Ukraine',
  ug: 'Uganda',
  us: 'United States',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vc: 'Saint Vincent and the Grenadines',
  ve: 'Venezuela',
  vn: 'Vietnam',
  vu: 'Vanuatu',
  ws: 'Samoa',
  ye: 'Yemen',
  za: 'South Africa',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};

export const countryEnMirror = makeMirror(countryEn);

// 国家(中文)
export const countryCn: {
  [key: string]: string;
} = {
  ad: '安道尔',
  ae: '阿联酋',
  af: '阿富汗',
  ag: '安提瓜和巴布达',
  al: '阿尔巴尼亚',
  am: '亚美尼亚',
  ao: '安哥拉',
  ar: '阿根廷',
  at: '奥地利',
  au: '澳大利亚',
  az: '阿塞拜疆',
  ba: '波斯尼亚和黑塞哥维那',
  bb: '巴巴多斯',
  bd: '孟加拉国',
  be: '比利时',
  bf: '布基纳法索',
  bg: '保加利亚',
  bh: '巴林',
  bi: '布隆迪',
  bj: '贝宁',
  bn: '文莱',
  bo: '玻利维亚',
  br: '巴西',
  bs: '巴哈马',
  bt: '不丹',
  bw: '博茨瓦纳',
  by: '白俄罗斯',
  bz: '伯利兹',
  ca: '加拿大',
  cf: '中非共和国',
  cg: '刚果',
  ch: '瑞士',
  ci: '科特迪瓦',
  ck: '库克群岛',
  cl: '智利',
  cm: '喀麦隆',
  cn: '中国',
  co: '哥伦比亚',
  cr: '哥斯达黎加',
  cu: '古巴',
  cv: '佛得角',
  cy: '塞浦路斯',
  cz: '捷克',
  cw: '库拉索',
  de: '德国',
  dj: '吉布提',
  dk: '丹麦',
  dm: '多米尼克',
  do: '多米尼加',
  dz: '阿尔及利亚',
  ec: '厄瓜多尔',
  ee: '爱沙尼亚',
  eg: '埃及',
  er: '厄立特里亚',
  es: '西班牙',
  et: '埃塞俄比亚',
  fi: '芬兰',
  fj: '斐济',
  fm: '密克罗尼西亚',
  fo: '法罗群岛',
  fr: '法国',
  ga: '加蓬',
  gb: '英国',
  gd: '格林纳达',
  ge: '格鲁吉亚',
  gh: '加纳',
  gm: '冈比亚',
  gn: '几内亚',
  gq: '赤道几内亚',
  gr: '希腊',
  gt: '危地马拉',
  gw: '几内亚比绍',
  gy: '圭亚那',
  hk: '中国香港',
  hn: '洪都拉斯',
  hr: '克罗地亚',
  ht: '海地',
  hu: '匈牙利',
  id: '印尼',
  ie: '爱尔兰',
  il: '以色列',
  in: '印度',
  iq: '伊拉克',
  ir: '伊朗',
  is: '冰岛',
  it: '意大利',
  jm: '牙买加',
  jo: '约旦',
  jp: '日本',
  ke: '肯尼亚',
  kg: '吉尔吉斯斯坦',
  kh: '柬埔寨',
  ki: '基里巴斯',
  km: '科摩罗',
  kn: '圣基茨和尼维斯',
  kp: '朝鲜',
  kr: '韩国',
  kw: '科威特',
  kz: '哈萨克斯坦',
  la: '老挝',
  lb: '黎巴嫩',
  lc: '圣卢西亚',
  lk: '斯里兰卡',
  lr: '利比里亚',
  ls: '莱索托',
  lt: '立陶宛',
  lu: '卢森堡',
  lv: '拉脱维亚',
  ly: '利比亚',
  ma: '摩洛哥',
  mc: '摩纳哥',
  md: '摩尔多瓦共和国',
  me: '黑山',
  mg: '马达加斯加',
  mh: '马绍尔群岛',
  mk: '北马其顿',
  ml: '马里',
  mm: '缅甸',
  mn: '蒙古',
  mo: '中国澳门',
  mr: '毛里塔尼亚',
  mt: '马耳他',
  mu: '毛里求斯',
  mv: '马尔代夫',
  mw: '马拉维',
  mx: '墨西哥',
  my: '马来西亚',
  mz: '莫桑比克',
  na: '纳米比亚',
  ne: '尼日尔',
  ng: '尼日利亚',
  ni: '尼加拉瓜',
  nl: '荷兰',
  no: '挪威',
  np: '尼泊尔',
  nr: '瑙鲁',
  nu: '纽埃',
  nz: '新西兰',
  om: '阿曼',
  pa: '巴拿马',
  pe: '秘鲁',
  pg: '巴布亚新几内亚',
  ph: '菲律宾',
  pk: '巴基斯坦',
  pl: '波兰',
  pt: '葡萄牙',
  pw: '帕劳',
  py: '巴拉圭',
  qa: '卡塔尔',
  ro: '罗马尼亚',
  rs: '塞尔维亚',
  ru: '俄罗斯',
  rw: '卢旺达',
  sa: '沙特阿拉伯',
  sb: '所罗门群岛',
  sc: '塞舌尔',
  sd: '苏丹',
  se: '瑞典',
  sg: '新加坡',
  si: '斯洛文尼亚',
  sk: '斯洛伐克',
  sl: '塞拉利昂',
  sm: '圣马力诺',
  sn: '塞内加尔',
  so: '索马里',
  sr: '苏里南',
  ss: '南苏丹',
  st: '圣多美和普林西比',
  sv: '萨尔瓦多',
  sy: '叙利亚',
  sz: '斯威士兰',
  td: '乍得',
  tg: '多哥',
  th: '泰国',
  tj: '塔吉克斯坦',
  tk: '托克劳',
  tl: '东帝汶',
  tm: '土库曼斯坦',
  tn: '突尼斯',
  to: '汤加',
  tr: '土耳其',
  tt: '特立尼达和多巴哥',
  tv: '图瓦卢',
  tw: '中国台湾',
  tz: '坦桑尼亚',
  ua: '乌克兰',
  ug: '乌干达',
  us: '美国',
  uy: '乌拉圭',
  uz: '乌兹别克斯坦',
  vc: '圣文森特和格林纳丁斯',
  ve: '委内瑞拉',
  vn: '越南',
  vu: '瓦努阿图',
  ws: '萨摩亚',
  ye: '也门',
  za: '南非',
  zm: '赞比亚',
  zw: '津巴布韦',
};

export const countryCnMirror = makeMirror(countryCn);

export const DAY = 'daily';
export const MONTH = 'monthly';
export const WEEK = 'weekly';
export const HOUR = 'hourly';
export const DAY_NORMAL = 'day';
export const MONTH_NORMAL = 'month';
export const WEEK_NORMAL = 'week';
export const HOUR_NORMAL = 'hour';

export const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';

export const dateTypeMap: Record<string, string> = {
  monthly: 'month',
  weekly: 'week',
  daily: 'day',
  hourly: 'hour',
};

export const dateFormatMap: Record<string, string> = {
  month: 'YYYY-MM',
  week: 'YYYY-MM-DD',
  day: 'YYYY-MM-DD',
  hour: 'YYYY-MM-DD HH:mm:ss',
};

export const sentimentIcon = [
  '',
  'laugh-green-color',
  'laugh-red-color',
  'laugh-grey-color',
];

export const sentimentIconMap: any = {
  0: '',
  1: 'laugh-red-color',
  3: 'laugh-grey-color',
  5: 'laugh-green-color',
};

export const channelColorMap: any = {
  facebook: '#5A7BE5',
  twitter: '#64C4F0',
  instagram: '#AB377D',
  reddit: '#FF6600',
  tiktok: '#000',
  youtube: '#CB1000',
  youtube_keyword: '#CB1000',
  twitch_keyword: '#8549EE',
  twitch: '#8549EE',
  discord: '#616FF1',
  vk: '#5E82AA',
  cafe: '#19CE60',
  navercafe: '#19CE60',
  navergame: '#02D961',
  bilibili: '#FE4B84',
  steam: '#31455D',
  steam_community: '#949BB3',
  'funcom forum': '#E2DFDF',
  kwai: '#FFAE4D',
  Others: '#B8BED1',
  others: '#B8BED1',
  ytg: '#CB1000',
  chzzk: '#00E693',
  afreeca: '#D5E342',
  douyin: '#4C5265',
};

/**
 * TODO: 其他系统使用
 * 提示文案
 */
export enum NO_DATE {
  SELECTION = 'No data under current filter selections.',
  SIMPLE = 'No data',
  TITLE = 'No data yet',
  LOADING = 'No data to load',
  DEFAULT = '-',
  ERROR = 'Loading failed, please refresh the page.',
  EMPTY = 'EMPTY',
  LOAD = 'Loading...',
}

// https://tapd.woa.com/20427644/prong/stories/view/1120427644887918386
// hok、暗区突围游戏、幻塔，声量数据不能包含这几个渠道
export const excludeChannels = [
  'hok_cbt_chatting',
  'tof_chatting',
  'uamo_chatting',
];
export const excludeChannelsGameIds = [
  'u10000000066', // hok
  'e5a30024b4b730fafefbabc383a8f171a', // hok
  'u6d721eb69ef7de198bb84be26be6d40b', // tof
  'e597156d0e947c96a6c9296fe80912a6d', // tof
  'e6d721eb69ef7de198bb84be26be6d40b', // tof
  'e0e60c94cf8c112223ff8cabe23867b2a', // tof
  'u6c4012121ae7a121fe4a77fc29e87160', // uamo
  'ef3bc65514b02801bcd84f67bbcbed563', // uamo
  // 'e8cf4268c5acf0adaa5aa539cf6c0c9af', // 测试
];

export function hasExcludeChannelsGameId(list: string[]) {
  if (!list || list.length === 0) return false;
  return list.some(id => excludeChannelsGameIds.includes(id));
}

export const PRE_HOSTNAMES = [
  // 'localhost', // 本地
  'databrain-pre.intlgame.com',
];

export const onlyShowInPre = (value: any) =>
  PRE_HOSTNAMES.includes(window.location.hostname) ? [value] : [];

export const GAME_MODE: { [key: number]: string } = {};

export const CONTACT_NAME = 'sophiaxwxu';
export const CONTACT_EMAIL = 'sophiaxwxu@tencent.com';
